import { render, staticRenderFns } from "./Platforms.vue?vue&type=template&id=a5b90864&"
import script from "./Platforms.vue?vue&type=script&lang=js&"
export * from "./Platforms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5b90864')) {
      api.createRecord('a5b90864', component.options)
    } else {
      api.reload('a5b90864', component.options)
    }
    module.hot.accept("./Platforms.vue?vue&type=template&id=a5b90864&", function () {
      api.rerender('a5b90864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Platforms/Platforms.vue"
export default component.exports